import { RootState, TypedDispatch } from "../../../../redux/store";
import { connect } from "react-redux";
import { AttendanceInitialStateDTO } from "../service/types";
import {
  attendanceEdit,
  attendanceList,
  attendanceMarkers,
  attendanceSave,
  attendanceStudentList,
} from "../service/attendanceSlice";
import AttendanceDetails from "../components/AttendanceDetails";

interface StateProps extends AttendanceInitialStateDTO {}

interface DispatchProps {
  GetAttendanceList(data: any): void;
  GetAttendanceMarkers(data: any): void;
  GetAttendanceStudentList(data: any): void;
  GetAttendanceSave(data: any): void;
  GetAttendanceEdit(data: any): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    success: state.attendance.success,
    error: state.attendance.error,
    loading: state.attendance.loading,
    attendanceListData: state.attendance.attendanceListData,
    attendanceMarkerError: state.attendance.attendanceMarkerError,
    attendanceMarkerLoading: state.attendance.attendanceMarkerLoading,
    attendanceMarkerSuccess: state.attendance.attendanceMarkerSuccess,
    attendanceMarkerData: state.attendance.attendanceMarkerData,
    attendanceStudentListError: state.attendance.attendanceStudentListError,
    attendanceStudentListLoading: state.attendance.attendanceStudentListLoading,
    attendanceStudentListSuccess: state.attendance.attendanceStudentListSuccess,
    attendanceStudentListData: state.attendance.attendanceStudentListData,
    attendanceStudentSaveError: state.attendance.attendanceStudentSaveError,
    attendanceStudentSaveLoading: state.attendance.attendanceStudentSaveLoading,
    attendanceStudentSaveSuccess: state.attendance.attendanceStudentSaveSuccess,
    attendanceStudentEditError: state.attendance.attendanceStudentEditError,
    attendanceStudentEditLoading: state.attendance.attendanceStudentEditLoading,
    attendanceStudentEditSuccess: state.attendance.attendanceStudentEditSuccess,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetAttendanceList: (data: any) => {
      dispatch(attendanceList(data));
    },
    GetAttendanceMarkers: (data: any) => {
      dispatch(attendanceMarkers(data));
    },
    GetAttendanceStudentList: (data: any) => {
      dispatch(attendanceStudentList(data));
    },
    GetAttendanceSave: (data: any) => {
      dispatch(attendanceSave(data));
    },
    GetAttendanceEdit: (data: any) => {
      dispatch(attendanceEdit(data));
    },
  };
};

export interface AttendanceProps extends StateProps, DispatchProps {}
export const AttendanceDetailsComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AttendanceDetails);
